export default class SaveDescriptionRequest {

    public id: string = "";

    public description: string | null = "";
}